export const Assets = {
  appStyleUrl: 'assets/css/style.min.css',
  appStyleRtlUrl: 'assets/css/style.rtl.min.css',
}